// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2HG_T","sendOtp":"AuthorizeToLogin_sendOtp__2oW7I"};